import * as amplitude from '@amplitude/analytics-browser'

type EventFunction<T> = (properties: T) => void

export function createEvent<T>(name: string): EventFunction<T> {
  return function (properties: T): void {
    amplitude.track(name, {
      ...properties,
      'Page URL': window.location.href.split('?')[0],
    })
  }
}
